<script>
  let {
    checked = $bindable(false),
    label,
    error,
    help,
    name,
    required = false,
    disabled = false
  } = $props()
  // Unique per instance: a drawer's fields share names with the page form behind it.
  const uid = $props.id()
  const fieldId = `${name}-${uid}`
</script>

<fieldset class="fieldset">
  <label class="label whitespace-normal cursor-pointer justify-start gap-2">
    <input
      type="checkbox"
      id={fieldId}
      {name}
      bind:checked
      class="toggle toggle-primary"
      class:toggle-error={!!error}      {disabled}
    />
    <span class="fieldset-legend">{label}{#if required}<span class="text-error"> *</span>{/if}</span>
  </label>
  {#if help && !error}<p class="label whitespace-normal">{help}</p>{/if}
  {#if error}<p class="text-error text-sm mt-1">{Array.isArray(error) ? error[0] : error}</p>{/if}
</fieldset>
